import React, { createClass, PropTypes } from 'react';
import SimpleMap from '../map';

const Address = createClass({

  propTypes: {
    address: PropTypes.object,
    className: PropTypes.string,
  },

  render() {
    let coordinates;
    let map;
    const address = this.props.address ? this.props.address : undefined;
    if (address) {
      if (address.loc) {
        if (address.loc.coordinates && address.loc.coordinates.length) {
          if (typeof(address.loc.coordinates) === 'string') {
            const longLat = address.loc.coordinates.split(',');
            coordinates = [longLat[1], longLat[0]];
          } else if (Array.isArray(address.loc.coordinates)) {
            coordinates = [address.loc.coordinates[1], address.loc.coordinates[0]];
          }
          // map = <SimpleMap coordinates={coordinates} googleMapsApi={window.google.maps} />;
        }
      }
    }
    if (!map) return false;

    return (
      <div className={this.props.className}>
        {map}
      </div>
    );
  },
});

export default Address;



// WEBPACK FOOTER //
// ./src/app/components/profile/company-address.jsx